/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./AddMssage.vue?vue&type=template&id=c35cdfb0&scoped=true&"
import script from "./AddMssage.vue?vue&type=script&lang=js&"
export * from "./AddMssage.vue?vue&type=script&lang=js&"
import style0 from "./AddMssage.vue?vue&type=style&index=0&id=c35cdfb0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c35cdfb0",
  null
  
)

export default component.exports